import React, { useMemo, useState, useEffect, useRef } from "react";
import "./style.scss";
import moment from "moment";
import Avatar from "react-avatar";
import ChatRoomSearch from "./ChatRoomSerach";
import ChatRoomTabs from "./ChatRoomTabs";
import { useCreateChatRoom, useGetUserSearch, useUpdateChatName, useHideRoom, useDeleteRoom } from "../../client-api";
const ChatRooms = ({ rooms, currentRoom, setCurrentRoom, account, setCreateNewRoomFlag }) => {
  const [search, setSearch] = useState("");
  const [tabType, setTabType] = useState("all");
  const [editChatNameModalOpen, setEditChatNameModalOpen] = useState(undefined);
  const [newChatName, setNewChatName] = useState('');
  const [openMenuRoomId, setOpenMenuRoomId] = useState(null);
  const menuRef = useRef(null);

  const totalUnreadCount = rooms.reduce(
    (n, { unreadCount }) => n + unreadCount,
    0
  );

  const { data: userSearchData } = useGetUserSearch(!!account);
  const { mutateAsync: createNewChatRoom } = useCreateChatRoom();
  const { mutate: mutateUpdateChatName } = useUpdateChatName();
  const { mutate: mutateHideRoom } = useHideRoom();
  const { mutate: mutateDeleteRoom } = useDeleteRoom();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuRoomId(null);
      }
    };
    if (openMenuRoomId) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openMenuRoomId]);

  const onCreateNewChatRoom = async (userId) => {
    const chatRoom = await createNewChatRoom([userId]);
    if (chatRoom) {
      setCurrentRoom(chatRoom.chatRoomId);
    }
  };

  const filteredRooms = useMemo(() => {
    if (search) {
      return rooms.filter((room) =>
        room.userIds.some((user) =>
          user.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
    if (tabType === "unread") {
      return rooms.filter((room) => room.unreadCount > 0);
    }
    return rooms;
  }, [search, tabType, rooms]);

  const filteredUsers = useMemo(() => {
    if (search) {
      const roomUsers = rooms
        .flatMap((room) => room.userIds)
        .map((user) => user._id);
      return userSearchData.filter(
        (user) =>
          !roomUsers.includes(user._id) &&
          user._id !== account._id &&
          user.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    return [];
  }, [search, userSearchData, rooms]);


  const onEditChatName = () => {
    mutateUpdateChatName(
      { roomId: editChatNameModalOpen, name: newChatName },
      {
        onSuccess: () => {
          setEditChatNameModalOpen(undefined);
          setNewChatName("");
        },
        onError: (err) => {
          console.error("Error updating chat name:", err);
        },
      }
    );
  }

  const roomBeingEdited = rooms.find((r) => r._id === editChatNameModalOpen);
  const isGroup = roomBeingEdited && roomBeingEdited.userIds.length > 2;

  return (
    <>
      <div className="Chat-rooms-container" style={{ position: 'relative' }}>
        <ChatRoomSearch search={search} setSearch={setSearch} />
        <div
          className='create-new-chat-container'
        >
          <ChatRoomTabs
            tabType={tabType}
            setTabType={setTabType}
            unreadCount={totalUnreadCount}
          />
          <button
            className='create-new-chat'
            onClick={() => {
              setCurrentRoom(null);
              setCreateNewRoomFlag(true);
            }}
          >
            +
          </button>
        </div>
        {filteredRooms.map((room) => {

          const activeClass = currentRoom === room._id ? "Chat-room-active" : "";
          const activeUsers = room.userIds.filter(
            (user) => user._id !== account._id
          );
          const lastMessageStr = room.lastMessage ?? "";
          const lastMessageText =
            lastMessageStr.length > 30
              ? `${lastMessageStr.slice(0, 20)}...`
              : lastMessageStr;
          const lastTime = moment(room.updatedAt).fromNow();

          return (
            <div
              key={room._id}
              className={`Chat-room ${activeClass}`}
              onClick={() => {
                setCreateNewRoomFlag(false);
                setCurrentRoom(room._id);
              }}
            >
              <div className="Chat-room-avatar">
                <Avatar
                  name={activeUsers[0].name}
                  src={activeUsers[0].profileImg}
                  size={50}
                  round={true}
                />
              </div>

              <div className="Chat-room-middle">
                <p className="Chat-room-middle-name">
                  {room.name && room.name !== '' ? room.name : activeUsers.map(user => user.name).join(',')}
                </p>
                <p className="Chat-room-middle-last">
                  {lastMessageText} {lastTime}
                </p>
              </div>

              <div className="Chat-room-end">
                {room.unreadCount > 0 && (
                  <div className="Chat-room-badge">{room.unreadCount}</div>
                )}

                <div className="chat-room-menu-wrapper" ref={openMenuRoomId === room._id ? menuRef : null}>
                  <button
                    className="chat-room-menu-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenMenuRoomId(openMenuRoomId === room._id ? null : room._id);
                    }}
                  >
                    ···
                  </button>

                  {openMenuRoomId === room._id && (
                    <div className="chat-room-menu-dropdown" onClick={(e) => e.stopPropagation()}>
                      <button
                        className="chat-room-menu-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenMenuRoomId(null);
                          setEditChatNameModalOpen(room._id);
                          const prefill = room.name && room.name !== ''
                            ? room.name
                            : activeUsers.map(u => u.name).join(', ');
                          setNewChatName(prefill);
                        }}
                      >
                        <img src="/edit.svg" alt="edit" className="chat-menu-icon" />
                        <span>編集</span>
                      </button>
                      <div className="chat-room-menu-divider" />
                      <button
                        className="chat-room-menu-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenMenuRoomId(null);
                          mutateHideRoom(room._id);
                        }}
                      >
                        <img src="/hide.svg" alt="hide" className="chat-menu-icon" />
                        <span>非表示</span>
                      </button>
                      <div className="chat-room-menu-divider" />
                      <button
                        className="chat-room-menu-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenMenuRoomId(null);
                          mutateDeleteRoom(room._id);
                        }}
                      >
                        <img src="/delete.svg" alt="delete" className="chat-menu-icon" />
                        <span>削除</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {filteredUsers.map((user) => {
          return (
            <div key={user._id} className={`Chat-room`}>
              <div
                style={{
                  width: "80%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "10px",
                }}
              >
                <Avatar
                  name={user.name}
                  src={user.profileImg}
                  size={50}
                  round={true}
                />
                <p
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "700",
                    color: "#1E1F23",
                  }}
                >
                  {user.name}
                </p>
              </div>
              <p
                onClick={() => {
                  onCreateNewChatRoom(user._id);
                }}
                style={{
                  display: "flex",
                  flex: 1,
                  fontSize: "0.8rem",
                  fontWeight: "700",
                  color: "#2B4773",
                  cursor: "pointer",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textDecoration: "underline",
                }}
              >
                DMを送る
              </p>
            </div>
          );
        })}
      </div>

      {editChatNameModalOpen ? (
        <div
          className="modal-edit"
          onClick={() => {
            setEditChatNameModalOpen(undefined);
            setNewChatName('');
          }}
        >
          <div
            className='edit-chat-name-modal'
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              height: "250px",
              textAlign: "center",
              display: editChatNameModalOpen ? "block" : "none"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: 'start',
                height: "100%",
              }}
            >
              <p style={{
                fontWeight: "bold",
                fontSize: "19px",
              }}>
                {isGroup ? "グループ名を編集" : "DM名を編集"}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: '100%',
                }}
              >
                <input
                  type="text"
                  maxLength={30}
                  value={newChatName}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(e) => setNewChatName(e.target.value)}
                  style={{
                    width: "100%",
                    margin: "20px 0",
                    padding: "8px",
                    fontSize: "16px",
                  }}
                />
                <button
                  className="edit-chat-name-button"
                  style={{
                    padding: "8px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: isGroup ? "35%" : "25%",
                    alignSelf: "flex-end",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditChatName()
                  }}
                >
                  {(() => {
                    return isGroup ? "グループ名を編集" : "DM名を編集";
                  })()}
                </button>
              </div>
            </div>
          </div>

        </div>) : null}
    </>
  );
};
export default ChatRooms;
